define('view/helper/DatePicker',['require','Config'],function (require) {
    var Config = require('Config');

   return {

        initDatepicker: function (element, options) {
            if (!options) {
                options = {};
            }

            var el = $(element);
            var datePicker = el.clone();
            // this._localizeDatePicker();
            var localisationOptions = this._getLocalisationParams();

            var config = Config.getInstance();
            var format = config.getOption('date_format');

            if(format){
                format = Date.convertPhpDateFormatToJs(format, true);
            }

            datePicker.attr('name', el.attr('name') + '_visible');
            datePicker.attr('id', el.attr('id') + '_visible');

            el.after(datePicker);
            el.attr('type', 'hidden');

            datePicker.datepicker(_.extend(options, localisationOptions, {
                format: format,
                zIndexOffset: 40,
                //todayBtn : true,
                todayHighlight : true
            }));

            if (el.val()) {
                datePicker.datepicker("setDate", Date.parseMysqlDate(el.val()));
            }
            
            this._initEvents(el, datePicker);

            return datePicker;
        },

        _initEvents : function (el, datePicker) {
            datePicker.on('changeDate', function (e) {
                if(e.date) {
                    el.val(e.date.getMysqlDate()).change();
                    //datePicker.val(e.date.formatDate());
                }
            });

            datePicker.keypress(function(e){
                return false;
            });

            datePicker.on('change', function () {
                var val = datePicker.val();

                if(!val){
                    el.val('').change();
                }
            });
            
            datePicker.on('show', function () {
                jQuery('.datepicker').attr('translate', 'no');
                Backbone.Wreqr.radio.vent.trigger('datepicker', 'show:datepicker', datePicker);
            }).on('hide', function () {
                Backbone.Wreqr.radio.vent.trigger('datepicker', 'hide:datepicker', datePicker);
            });
        },

       // _localizeDatePicker: function () {
       _getLocalisationParams: function () {
           var date = new Date();

           var firstDay = 0;
           if (Config.getInstance().isMondayFirstDay()) {
               firstDay = 1;
           }

           // NB! this was copy-pasted from BootstrapInlineDatepicker
           // but I not sure is it used now. If yes we should check does weekStart applyes ok there
           // jQuery.fn.datepicker.dates.custom =
           return   {
               days: _.map(date.weekDaysLong, this._t),
               daysShort: _.map(date.weekDayMedium, this._t),
               daysMin: _.map(date.weekDayMedium, this._t),
               months: _.map(date.monthsLong, _.bind(function (val) {
                   return this._t('_' + val + '_');
               }, this)),
               monthsShort: _.map(date.monthsShort, this._t),
               weekStart: firstDay
           };
       },

       _t: function (str) {
           return Locale.get(str);
       }
    };

});

